/**
 * @file home页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-08-28 Baidu
 */

import React from 'react';
import {Table, Tabs, Icon, Divider} from 'antd';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import {requestDemo} from './requestDemo';
import {setCurrentPage} from '../../actions/generalAction';
import './index.less';

const TabPane = Tabs.TabPane;

const createResDemo = `
{
    "Code": -99,
    "ShortUrls": [
        {
            "ShortUrl": "https://dwz.cn/de3rp2Fl",
            "LongUrl": "https://www.baidu.com"
        },
        {
            "Code": -11,
            "LongUrl": "https://notexsit.dwz.cn",
            "ErrMsg": "long URL with unsupported host"
        },
    ],
    "ErrMsg": "partial fail"
}`;
const queryResDemo = `
{
    "Code": 0,
    "LongUrl": "https://www.baidu.com"
}`;
const deleteResDemo = `
{
    "Code": -2,
    "ErrMsg": "short URL not exists"
}`;
const changeResDemo = `
{
    "Code": 0,
    "ErrMsg": ""
}`;
const renderContentOfCreate = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 13;
    }
    else if (index <= 12) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};
const renderContentOfQuery = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 5;
    }
    else if (index <= 4) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};
const renderContentOfDelete = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 6;
    }
    else if (index <= 5) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};

const renderContentOfChange = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 15;
    }
    else if (index <= 14) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
}
class APIDoc extends React.Component {
    state = {
        announceDisplay: 'block'
    }
    linkToUserInfo() {
        _hmt.push(['_trackEvent', 'API接口文档页', 'apidoc_click_tokenlink', '点击获取Token链接']);
        this.props.dispatch(setCurrentPage('userinfo'));
    }
    // linkToApiDocV2() {
    //     document.documentElement.scrollTop = document.body.scrollTop = 0;
    // }
    closeAnnoce() {
        this.setState({
            announceDisplay: 'none'
        });
    }
    render() {
        const headers = [
            {
                title: '字段',
                dataIndex: 'field',
                key: 'field'
            },
            {
                title: '类型',
                dataIndex: 'valueType',
                key: 'valueType'
            },
            {
                title: '是否必须',
                dataIndex: 'require',
                key: 'require'
            },
            {
                title: '说明',
                dataIndex: 'description',
                key: 'description',
                render: (text, _) => (
                    <span>
                        {text}
                        {text === '短网址有效期，目前支持：'
                            && <span>
                                <ul className="termOfValidityDes">
                                <li>"long-term"：长期</li>
                                <li>"1-year"：1年</li>
                            </ul>
                            </span>
                        }
                        {text === '长网址'
                            && <span>
                                <ul className="termOfValidityDes">
                                <li>免费用户单次请求不超过 1 条</li>
                                <li>付费用户单次请求不超过 5 条</li>
                            </ul>
                            </span>
                        }
                    </span>
                )
            },
            {
                title: '示例',
                dataIndex: 'valueDemo',
                key: 'valueDemo',
                render: (text, row, index) => {
                    const content = (
                        <Link to="/console/userinfo" onClick={() => this.linkToUserInfo()}>{text}</Link>
                    );
                    if (text === '获取token') {
                        return {
                            children: content,
                        };
                    };
                    return text;
                }
            }];
        const queries = {
            changeBody: [{
                key: 1,
                field: 'LongUrl',
                valueType: 'string',
                require: '必须',
                description: '新的长网址',
                valueDemo: '"http://www.baidu.com"'
            }],
            createHeaders: [{
                key: 1,
                field: 'Dwz-Token',
                valueType: 'string',
                require: '必须',
                description: '用户鉴权信息',
                valueDemo: '获取token'
            }, {
                key: 2,
                field: 'Content-Type',
                valueType: 'string',
                require: '必须',
                description: '内容类型',
                valueDemo: 'application/json; charset=UTF-8'
            }, {
                key: 3,
                field: 'Content-Language',
                valueType: 'string',
                require: '非必须',
                description: '返回错误语言',
                valueDemo: 'zh'
            }],
            createBody: [{
                key: 1,
                field: 'LongUrl',
                valueType: 'string',
                require: '必须',
                description: '长网址',
                valueDemo: '"http://www.baidu.com"'
            }, {
                key: 2,
                field: 'TermOfValidity',
                valueType: 'string',
                require: '必须',
                description: '短网址有效期，目前支持：',
                valueDemo: '"long-term"'
            }],
            queryPath: [{
                key: 1,
                field: 'short_path',
                valueType: 'string',
                require: '必须',
                description: '短网址后缀，如http://dwz.cn/xxxxxxxx中的xxxxxxxx',
                valueDemo: 'xxxxxxxx'
            }],
            queryHeader: [{
                key: 1,
                field: 'Dwz-Token',
                valueType: 'string',
                require: '必须',
                description: '用户鉴权信息',
                valueDemo: '获取token'
            }, {
                key: 2,
                field: 'Content-Language',
                valueType: 'string',
                require: '非必须',
                description: '返回错误语言',
                valueDemo: 'zh'
            }],
            deletePath: [{
                key: 1,
                field: 'short_path',
                valueType: 'string',
                require: '必须',
                description: '短网址后缀，如http://dwz.cn/xxxxxxxx中的xxxxxxxx',
                valueDemo: 'xxxxxxxx'
            }],
            deleteHeader: [{
                key: 1,
                field: 'Dwz-Token',
                valueType: 'string',
                require: '必须',
                description: '用户鉴权信息',
                valueDemo: '获取token'
            }, {
                key: 2,
                field: 'Content-Language',
                valueType: 'string',
                require: '非必须',
                description: '返回错误语言',
                valueDemo: 'zh'
            }],
        };
        return (
            <div className="doc-container">
                <div className="apidoc-content">
                    <h2 className="title">短网址生成接口</h2>
                    <ul>
                        <h3>接口说明</h3>
                        <li>
                            <span>支持批量创建</span>
                        </li>
                        <li>
                            <span>支持定制域名：生成短网址域名与接口请求域名相同。</span>
                        </li>
                        <li>
                            <span>QPS限制说明：免费用户限制10QPS(共享集群容量限制)；付费用户限制100QPS(共享集群容量限制)；
                                如需更高QPS请联系商务进行沟通确认；如需专享集群请联系商务进行沟通确认。</span>
                        </li>
                        <h3>请求地址</h3>
                        <li>
                            <span>协议：https</span>
                        </li>
                        <li>
                            <span>域名：{this.props.address.domain}</span>
                        </li>
                        <li>
                            <span>路径：/api/v3/short-urls</span>
                        </li>
                        <li>
                            <span>方法：POST</span>
                        </li>
                        <h3>请求参数（Headers）</h3>
                        <Table columns={headers} dataSource={queries.createHeaders} pagination={false} />
                        <h3>请求参数（Body）</h3>
                        <Table columns={headers} dataSource={queries.createBody} pagination={false} />
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="curl" key="1"><pre>{requestDemo().curl.create}</pre></TabPane>
                            <TabPane tab="Python" key="2">
                                <p><a href={requestDemo().python} target="_blank">Python 优秀实践</a></p>
                            </TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.create.createResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.create.resHead} dataSource={this.props.create.resBody} pagination={false} />
                    </ul>
                    <Divider className='divider'/>
                    <h2 className="title">短网址查询接口</h2>
                    <ul>
                        <h3>接口说明</h3>
                        <li>
                            <span>支持查询自己或他人创建的短网址信息</span>
                        </li>
                        <h3>请求地址</h3>
                        <li>
                            <span>协议：https</span>
                        </li>
                        <li>
                            <span>域名：{this.props.address.domain}</span>
                        </li>
                        <li>
                            <span>{'路径：/api/v3/short-urls/{short_path}'}</span>
                        </li>
                        <li>
                            <span>方法：GET</span>
                        </li>
                        <h3>请求参数（Path）</h3>
                        <Table columns={headers} dataSource={queries.queryPath} pagination={false} />
                        <h3>请求参数（Headers）</h3>
                        <Table columns={headers} dataSource={queries.queryHeader} pagination={false} />
                        <h3>请求参数（Body）</h3>
                        <li>
                            <span>无</span>
                        </li>
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="curl" key="1"><pre>{requestDemo().curl.query}</pre></TabPane>
                            <TabPane tab="Python" key="2">
                                <p><a href={requestDemo().python} target="_blank">Python 优秀实践</a></p>
                            </TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.query.queryResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.query.resHead} dataSource={this.props.query.resBody} pagination={false} />
                    </ul>
                    <Divider className='divider'/>
                    <h2 className="title">短网址删除接口</h2>
                    <ul>
                        <h3>接口说明</h3>
                        <li>
                            <span>短网址删除成功后，因服务缓存机制，短时间内依然可以访问，1小时内删除可完全生效。</span>
                        </li>
                        <h3>请求地址</h3>
                        <li>
                            <span>协议：https</span>
                        </li>
                        <li>
                            <span>域名：{this.props.address.domain}</span>
                        </li>
                        <li>
                            <span>{'路径：/api/v3/short-urls/{short_path}'}</span>
                        </li>
                        <li>
                            <span>方法：DELETE</span>
                        </li>
                        <h3>请求参数（Path）</h3>
                        <Table columns={headers} dataSource={queries.deletePath} pagination={false} />
                        <h3>请求参数（Headers）</h3>
                        <Table columns={headers} dataSource={queries.deleteHeader} pagination={false} />
                        <h3>请求参数（Body）</h3>
                        <li>
                            <span>无</span>
                        </li>
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="curl" key="1"><pre>{requestDemo().curl.delete}</pre></TabPane>
                            <TabPane tab="Python" key="2">
                                <p><a href={requestDemo().python} target="_blank">Python 优秀实践</a></p>
                            </TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.delete.deleteResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.delete.resHead}
                            dataSource={this.props.delete.resBody}
                            pagination={false} />
                    </ul>
                    <Divider className='divider' />
                    <h2 className="title">短网址修改接口</h2>
                    <ul>
                        <h3>接口说明</h3>
                        <li><span>支持修改单个短网址对应的长网址</span></li>
                        <li><span>支持定制域名：生成短网址域名与接口请求域名相同</span></li>
                        <li><span>一分钟内特定短网址仅可修改一次</span></li>
                        <li><span>短网址修改成功后，因服务缓存机制，短时间内依然有可能指向原长网址，1小时内更新可完全生效</span></li>
                        <li><span>更新需要重新审核并计费：一年期链接更新扣1点，长期链接更新一次扣2点</span></li>
                        <li><span>暂不支持应用内长链跳转</span></li>
                        <h3>请求地址</h3>
                        <li><span>协议：https</span></li>
                        <li><span>域名：{this.props.address.domain}</span></li>
                        <li><span>{'路径：/api/v3/short-urls/{short_path}'}</span></li>
                        <li><span>方法：PATCH</span></li>
                        <h3>请求参数（Headers）</h3>
                        <Table columns={headers} dataSource={queries.createHeaders} pagination={false} />
                        <h3>请求参数（Headers）</h3>
                        <Table columns={headers} dataSource={queries.changeBody} pagination={false} />
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="curl" key="1"><pre>{requestDemo().curl.change}</pre></TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.change.changeResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.change.resHead}
                            dataSource={this.props.change.resBody}
                            pagination={false} />
                    </ul>
                </div>
            </div>
        );
    }
}
APIDoc.defaultProps = {
    address: {
        domain: 'dwz.cn 或 定制域名（*.dwz.cn)'
    },
    create: {
        reqDemo: '{"Url":"http://www.baidu.com"}',
        createResDemo,
        reqHead: [{
            title: '字段',
            dataIndex: 'crReqName',
            key: 'crReqName'
        },
        {
            title: '类型',
            dataIndex: 'crReqType',
            key: 'crReqType'
        },
        {
            title: '是否必须',
            dataIndex: 'crReqRequire',
            key: 'crReqRequire'
        },
        {
            title: '说明',
            dataIndex: 'crReqDescribe',
            key: 'crReqDescribe',
            render: (text, _) => (
                <span>
                    {text}
                    {text === '短网址有效期，目前支持：'
                        && <span>
                            <ul className="termOfValidityDes">
                            <li>"long-term"：长期</li>
                            <li>"1-year"：1年</li>
                        </ul>
                        </span>
                    }
                    {text === '长网址'
                        && <span>
                            <ul className="termOfValidityDes">
                            <li>免费用户单次请求不超过 1 条</li>
                            <li>付费用户单次请求不超过 5 条</li>
                        </ul>
                        </span>
                    }
                </span>
            )
        },
        {
            title: '示例',
            dataIndex: 'crReqDemo',
            key: 'crReqDemo'
        }],
        reqBody: [
            {
                key: 1,
                crReqName: 'LongUrl',
                crReqType: 'string',
                crReqRequire: '必须',
                crReqDescribe: '长网址',
                crReqDemo: '"http://www.baidu.com"'
            },
            {
                key: 2,
                crReqName: 'TermOfValidity',
                crReqType: 'string',
                crReqRequire: '必须',
                crReqDescribe: '短网址有效期，目前支持：',
                crReqDemo: '"long-term"'
            }
        ],
        // create head
        resHead: [{
            title: '字段',
            dataIndex: 'crResName',
            key: 'crResName',
            render: renderContentOfCreate
        },
        {
            title: '类型',
            dataIndex: 'crResType',
            key: 'crResType',
            render: renderContentOfCreate
        },
        {
            title: '说明',
            dataIndex: 'crResDescribe',
            key: 'crResDescribe',
            render: (text, _) => {
                const safetyAudit = (
                    <span>
                    -13：长网址可能存在安全风险，可申请 <a href='https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=898' target='_black'>安全审核</a> 解决
                    </span>
                );
                const realName = (
                    <span>
                       -114：账号需进行 <a href='https://cloud.baidu.com/doc/UserGuide/s/Ajwvy3ckg' target='_black'>企业实名认证</a>
                    </span>
                );
                if (text === '-13：长网址可能存在安全风险，可申请安全审核解决') {
                    return {
                        children: safetyAudit,
                    };
                } else if (text === '-114：账号需进行企业实名认证') {
                    return {
                        children: realName,
                    };
                }
                return text;
            },
        }],
        // create body
        resBody: [{
            key: 1,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '以下为常见返回码：'
        },
        {
            key: 2,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '0：请求成功'
        },
        {
            key: 3,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-10：无效长网址'
        },
        {
            key: 4,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-11：长网址不支持缩短'
        },
        {
            key: 5,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-13：长网址可能存在安全风险，可申请安全审核解决'
        },
        {
            key: 6,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-14：长网址数量过多'
        },
        {
            key: 7,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-20：有效期设置错误'
        },
        {
            key: 8,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-21：长期有效额度不足'
        },
        {
            key: 9,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-30：可用点数不足'
        },
        {
            key: 10,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-91：域名设置错误'
        },
        {
            key: 11,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-99：部分长网址缩短失败'
        },
        {
            key: 12,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-100：Token验证失败'
        },
        {
            key: 13,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-114：账号需进行企业实名认证'
        },
        {
            key: 14,
            crResName: 'ShortUrl',
            crResType: 'string',
            crResDescribe: '短网址'
        },
        {
            key: 15,
            crResName: 'LongUrl',
            crResType: 'string',
            crResDescribe: '长网址（原网址）'
        },
        {
            key: 16,
            crResName: 'ErrMsg',
            crResType: 'string',
            crResDescribe: '错误信息'
        }]

    },
    query: {
        reqDemo: '{"shortUrl": "https://dwz.cn/de3rp2Fl"}',
        queryResDemo,
        reqHead: [{
            title: '字段',
            dataIndex: 'quReqName',
            key: 'quReqName'
        },
        {
            title: '类型',
            dataIndex: 'quReqType',
            key: 'quReqType'
        },
        {
            title: '是否必须',
            dataIndex: 'quReqRequire',
            key: 'quReqRequire'
        },
        {
            title: '说明',
            dataIndex: 'quReqDescribe',
            key: 'quReqDescribe'
        },
        {
            title: '示例',
            dataIndex: 'quReqDemo',
            key: 'quReqDemo'
        }],
        reqBody: [{
            key: 1,
            quReqName: 'shortUrl',
            quReqType: 'string',
            quReqRequire: '必须',
            quReqDescribe: '短网址',
            quReqDemo: '"https://dwz.cn/de3rp2Fl"'
        }],
        // create response TableHead
        resHead: [{
            title: '字段',
            dataIndex: 'quResName',
            key: 'quResName',
            render: renderContentOfQuery
        },
        {
            title: '类型',
            dataIndex: 'quResType',
            key: 'quResType',
            render: renderContentOfQuery
        },
        {
            title: '说明',
            dataIndex: 'quResDescribe',
            key: 'quResDescribe'
        }],
        // query response tableBody
        resBody: [{
            key: 1,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '以下为常见返回码：'
        },
        {
            key: 2,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '0：成功'
        },
        {
            key: 3,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-1：短网址参数错误'
        },
        {
            key: 4,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-2/-4：短网址不存在'
        },
        {
            key: 5,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-100：Token验证失败'
        },
        {
            key: 6,
            quResName: 'LongUrl',
            quResType: 'string',
            quResDescribe: '长网址（原网址）'
        },
        {
            key: 7,
            quResName: 'ErrMsg',
            quResType: 'string',
            quResDescribe: '错误信息'
        }]
    },
    delete: {
        deleteResDemo,
        resHead: [{
            title: '字段',
            dataIndex: 'delResName',
            key: 'delResName',
            render: renderContentOfDelete
        },
        {
            title: '类型',
            dataIndex: 'delResType',
            key: 'delResType',
            render: renderContentOfDelete
        },
        {
            title: '说明',
            dataIndex: 'delResDescribe',
            key: 'delResDescribe'
        }],
        resBody: [{
            key: 1,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '以下为常见返回码：'
        },
        {
            key: 2,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '0：成功'
        },
        {
            key: 3,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-1：短网址参数错误'
        },
        {
            key: 4,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-2/-4：短网址不存在'
        },
        {
            key: 5,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-3：无权操作短网址'
        },
        {
            key: 6,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-100：Token验证失败'
        },
        {
            key: 7,
            delResName: 'ErrMsg',
            delResType: 'string',
            delResDescribe: '错误信息'
        }]
    },
    change: {
        changeResDemo,
        resHead: [{
            title: '字段',
            dataIndex: 'delResName',
            key: 'delResName',
            render: renderContentOfChange
        },
        {
            title: '类型',
            dataIndex: 'delResType',
            key: 'delResType',
            render: renderContentOfChange
        },
        {
            title: '说明',
            dataIndex: 'delResDescribe',
            key: 'delResDescribe',
            render: (text, _) => {
                const safetyAudit = (
                    <span>
                    -13：长网址可能存在安全风险，可申请 <a href='https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=898' target='_black'>安全审核</a> 解决
                    </span>
                );
                const realName = (
                    <span>
                       -114：账号需进行 <a href='https://cloud.baidu.com/doc/UserGuide/s/Ajwvy3ckg' target='_black'>企业实名认证</a>
                    </span>
                );
                if (text === '-13：长网址可能存在安全风险，可申请安全审核解决') {
                    return {
                        children: safetyAudit,
                    };
                } else if (text === '-114：账号需进行企业实名认证') {
                    return {
                        children: realName,
                    };
                }
                return text;
            },
        }],
        resBody: [{
            key: 1,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '以下为常见返回码：'
        }, {
            key: 2,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '0：请求成功'
        },
        {
            key: 3,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-1：短网址不属于该token创建'
        },
        {
            key: 4,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-10：无效长网址'
        },
        {
            key: 5,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-11：长网址不支持缩短'
        },
        {
            key: 6,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-13：长网址可能存在安全风险，可申请安全审核解决'
        },
        {
            key: 7,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-14：长网址数量过多'
        },
        {
            key: 8,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-20：有效期设置错误'
        },
        {
            key: 9,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-21：长期有效额度不足'
        },
        {
            key: 10,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-30：可用点数不足'
        },
        {
            key: 11,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-91：域名设置错误'
        },
        {
            key: 12,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-99：部分长网址缩短失败'
        },
        {
            key: 13,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-100：Token验证失败'
        },
        {
            key: 14,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-104：修改过于频繁 一分钟内特定短网址仅可修改一次'
        },
        {
            key: 15,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-114：账号需进行企业实名认证'
        },
        {
            key: 16,
            delResName: 'ErrMsg',
            delResType: 'string',
            delResDescribe: '错误信息'
        }]
    }
};
export default connect(state => ({
    currentPage: state.currentPage
}))(APIDoc);
